// snippets/nr-ingredient-table-paged.liquid (the paged layout of nr-ingredient-table): the arrows and dots page through the ingredient tables.
if (!customElements.get('nr-ingredient-table-paged')) {
  customElements.define(
    'nr-ingredient-table-paged',
    class extends HTMLElement {
      connectedCallback() {
        this.panels = [...this.querySelectorAll('.nr-ingredient-table-paged__panel')];
        this.dots = [...this.querySelectorAll('.nr-ingredient-table-paged__dot')];
        this.arrows = [...this.querySelectorAll('.nr-ingredient-table-paged__arrow')];
        this.index = 0;
        this.arrows.forEach((arrow) =>
          arrow.addEventListener('click', () => this.show(this.index + Number(arrow.dataset.step)))
        );
      }

      show(index) {
        if (index < 0 || index >= this.panels.length) return;
        this.index = index;
        this.panels.forEach((panel, i) => (panel.hidden = i !== index));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        this.arrows.forEach((arrow) => {
          const step = Number(arrow.dataset.step);
          arrow.disabled = step < 0 ? index === 0 : index === this.panels.length - 1;
        });
      }
    }
  );
}
